import {ngAsync} from 'shared/utils/ng-@decorators';
import {unRestangularize} from 'shared/utils/data-service-utils';
import type {Fond} from 'typings/portaro.be.types';

/**
 * @ngdoc service
 * @name fondsDataService
 * @module use-cases.fonds
 *
 * @requires Restangular
 *
 * @description
 * Data service for providing the newest documents
 */
export default class FondsDataService {
    public static serviceName = 'fondsDataService';

    private static readonly ROUTE = 'fonds';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async getAll(): Promise<Fond[]> {
        return this.Restangular
            .one(FondsDataService.ROUTE)
            .getList<Fond>();
    }
}
